<template>
  <div id="CourseOpeningList" v-loading="loading">
    <el-dialog :visible.sync="dialogVisible" width="80%">
      <el-table
        ref="table"
        :data="tableData"
        border
        style="width: 100%"
        size="small"
        :header-cell-style="{ 'background-color': '#e8eff9' }"
      >
        <el-table-column prop="batch" label="班级编码"> </el-table-column>
        <el-table-column prop="mhName" label="课程名称"></el-table-column>
        <el-table-column prop="openTeacher" label="创建学校"></el-table-column>
        <el-table-column prop="openTeacher" label="讲师"></el-table-column>
        <el-table-column
          prop="courseValidTime"
          label="课程有效时间"
        ></el-table-column>
        <el-table-column prop="openDate" label="开课时间"></el-table-column>
        <el-table-column
          prop="courseEndDate"
          label="结课时间"
        ></el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <div :class="scope.row.status === '开课中' ? 'openingClass' : ''">
              {{ scope.row.status }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="学习结果">
          <template>
            <div style="cursor: pointer" @click="checkLearingOutcome">查看</div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageObj.page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageObj.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        background
        :total="total"
      >
      </el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import * as api from '@/api/courseware/checkCourseware'
export default {
  data() {
    return {
      courseId: this.$route.query.id,
      loading: false,
      dialogVisible: true,
      tableData: [{}],
      // 分页
      pageObj: {
        page: 1,
        pageSize: 20,
      },
      // 总数
      total: 0,
    }
  },
  watch: {
    tableData: {
      handler(newVal, oldVal) {
        const now = new Date().getTime()
        newVal.forEach((item) => {
          const openDate = new Date(item.openDate).valueOf()
          const courseEndDate = new Date(
            item.courseEndDate + ' 23:59:59'
          ).valueOf()
          if (item.status === 0) {
            if (now < openDate) {
              item.status = '未开课'
            } else {
              if (now <= courseEndDate) {
                item.status = '开课中'
              } else {
                item.status = '课程结束'
              }
            }
          } else if (item.status === 1) {
            item.status = '已作废'
          }
        })
      },
      deep: true,
    },
  },
  methods: {
    getCourseRecordList() {
      api
        .getCourseRecordList({ courseId: this.courseId, ...this.pageObj })
        .then(({ data }) => {
          if (data.code === 100000) {
            this.tableData = data.data.list
            this.total = data.data.total
          }
        })
    },

    // 改变页面接收数据大小
    handleSizeChange(val) {
      this.pageObj.pageSize = val
      this.getCourseRecordList()
    },

    // 改变当前页面
    handleCurrentChange(val) {
      this.pageObj.page = val
      this.getCourseRecordList()
    },
    checkLearingOutcome() {
      this.$router.push('/ClassLearningOutcome?courseId=198')
    },
  },
  created() {
    // this.getCourseRecordList()
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/.el-tabs__item {
  font-size: 12px;
}
/deep/.el-tabs__item {
  padding: 0 10px !important;
}
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li {
  background-color: #e2e8f4;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #265480;
}
.openingClass {
  color: #04f91d;
}
</style>